/* Core & libraries */
import React from "react";
/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../contexts/userContext";

/* Components */
import InvitePeopleModal from "../modals/invitePeopleModal";
import InviteAuthorisedModal from "../modals/inviteAuthorisedModal";
import {AIRLINES} from "../../constants/appConstants";

/* Styles */


const GlobalComponents = () => {
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  return (
    <>
      <InvitePeopleModal />
      {
        providerCode === AIRLINES.AA &&
        <InviteAuthorisedModal />
      }
    </>
  )
}

export default GlobalComponents;
